/**
 * Return a shallow copy with all falsy values (null, undefined, '', 0, false)
 * removed. Used to keep request payloads lean — only send the fields we have.
 */
export function filterFalsyValues<T extends object>(obj: T): Partial<T> {
  const result: Partial<T> = {};
  (Object.keys(obj) as (keyof T)[]).forEach((key) => {
    if (obj[key]) {
      result[key] = obj[key];
    }
  });
  return result;
}
